import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { RolesManagementPage } from '../rbac/RolesManagementPage';

export const LegacyRbacRoute: React.FC = () => {
  const { user } = useAuth();

  if (user?.context === 'dealership') {
    return <Navigate to="/settings/role-access" replace />;
  }

  return <RolesManagementPage />;
};
